export default function () {
  $('#deployment_environment_temp').change(function() {
    updateVisibleFields();
  });

  function updateVisibleFields() {
    var isTemp = $('#deployment_environment_temp').is(':checked');

    if (isTemp) {
      disable($('#deployment_environment_name'));
      disable($('#deployment_environment_jobName'));
      disable($('#deployment_environment_hosts'));
      $('.message-permanent').hide();
      $('.message-temp').show();
    } else {
      enable($('#deployment_environment_name'));
      enable($('#deployment_environment_jobName'));
      enable($('#deployment_environment_hosts'));
      $('.message-temp').hide();
      $('.message-permanent').show();
    }
  };

  function disable(field) {
      field.attr('disabled', true);
      field.data('oldVal', field.val());
      field.val('');
  }

  function enable(field) {
      field.attr('disabled', false);
      var oldVal = field.data('oldVal');
      if (oldVal) {
        field.val(oldVal);
      }
  }

  $('#deployment_environment_template').change(updateTemplate);

  function updateTemplate() {
    const templateId = $('#deployment_environment_template').val();
    if (!templateId) {
      $('.data-template-hcl').text('');
      $('.data-template-slug').text('(not selected)');
      $('.data-template-updated').text('');
      return;
    }
    $.ajax({
      url: '/api/deployment-templates/'+templateId,
      type: 'get',
      success: (data) => {
        $('.data-template-hcl').text(data.hcl);
        $('.data-template-slug').text(data.slug);
        $('.data-template-updated').text(data.updatedAt);
      }
    });
  }

  updateVisibleFields();
  updateTemplate();
};



// WEBPACK FOOTER //
// ./assets/js/create-deployment-environment.js